import React, { useState, useEffect } from "react";
import { ProSidebar, SidebarContent } from "react-pro-sidebar";
import { useNavigate, useLocation } from 'react-router-dom';
import "./responsive.css";
import "./menubar.scss";
import TataLogo from '../../images/TATA_ELXSI.svg';
import { useParams } from 'react-router-dom';
import { loginReducer, sidebarReducer } from "../../Redux/store";
import "react-pro-sidebar/dist/css/styles.css";
import { useDispatch, useSelector } from "react-redux";
import dashboard_one from "../../images/dashboard_one.svg";
import dashboard_two from "../../images/dashboard_two.svg";
import liceses_one from "../../images/liceses_one.svg";
import liceses_two from "../../images/liceses_two.svg";
import software_one from "../../images/software_one.svg";
import software_two from "../../images/software_two.svg";
import sales_orderone from "../../images/sales_orderone.svg";
import sales_ordertwo from "../../images/sales_ordertwo.svg";



const Aside = () => {
  const { te_companyid, te_lmsid } = useParams();
//  console.log("orderid",orderid)
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState(null);
  const [iconState, setIconState] = useState({
    DashBoard: dashboard_one,
    liceses: liceses_one,
    Software: software_one,
    SalesOrder: sales_orderone
  });


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userParam = params.get("orderid");
   console.log("123423513652442",userParam)
}, []);

// console.log("window.location.pathname",window.location.pathname)


  useEffect(() => {
    switch (location.pathname) {
      case "/dashboard":
        setIconState(prevState => ({
          ...prevState,
          DashBoard: dashboard_two,
          liceses: liceses_one,
          Software: software_one,
          SalesOrder: sales_orderone
        }));
        break;
      case "/liceses" :
        setIconState(prevState => ({
          ...prevState,
          DashBoard: dashboard_one,
          liceses: liceses_two,
          Software: software_one,
          SalesOrder: sales_orderone
        }));
        break;
        case "/LiceseDetails/"+te_lmsid  :
          setIconState(prevState => ({
            ...prevState,
            DashBoard: dashboard_one,
            liceses: liceses_two,
            Software: software_one,
            SalesOrder: sales_orderone
          }));
          break;
          case "/CompanyDetails/" +te_companyid+"/"+te_lmsid :
          setIconState(prevState => ({
            ...prevState,
            DashBoard: dashboard_one,
            liceses: liceses_two,
            Software: software_one,
            SalesOrder: sales_orderone
          }));
          break;
      case "/Software":
        setIconState(prevState => ({
          ...prevState,
          DashBoard: dashboard_one,
          liceses: liceses_one,
          Software: software_two,
          SalesOrder: sales_orderone
        }));
        break;
      case "/SalesOrder":
        setIconState(prevState => ({
          ...prevState,
          DashBoard: dashboard_one,
          liceses: liceses_one,
          Software: software_one,
          SalesOrder: sales_ordertwo
        }));
        break;
        case "/CreateOrder":
        setIconState(prevState => ({
          ...prevState,
          DashBoard: dashboard_one,
          liceses: liceses_one,
          Software: software_one,
          SalesOrder: sales_ordertwo
        }));
        break;
        case "/CreateOrder/":
          setIconState(prevState => ({
            ...prevState,
            DashBoard: dashboard_one,
            liceses: liceses_one,
            Software: software_one,
            SalesOrder: sales_ordertwo
          }));
          break;
      default:
        break;
    }
  }, [location.pathname]);

  const handleItemClick = (path, icon) => {
    setSelectedItem(path);
    setIconState(prevState => ({
      ...prevState,
      [path]: icon
    }));
    dispatch(sidebarReducer.stringUpdate(path));
    navigate('/' + path);
  };

  const isActive = (path) => {
    const currentPath = location.pathname;
    return currentPath === `/${path}` ||
      (path === "dashboard" && currentPath === "/") ||
      (path === "liceses" && (currentPath === "/liceses" || currentPath === "/LiceseDetails/"+te_lmsid || currentPath === "/CompanyDetails/"+te_companyid+"/"+te_lmsid)) ||
      (path === "Software" && currentPath === "/Software") ||
      (path === "SalesOrder" && (currentPath === "/SalesOrder" || currentPath === "/CreateOrder" || currentPath === "/CreateOrder/"));
  };

  return (
    <div style={{ overflowY: "none !important" }}>
      <ProSidebar
        id="sidebar"
        breakPoint="md"
      >
        <SidebarContent>
          <div className="user-details-section">
            <div>
              <img
                className="user-image"
                src={TataLogo}
                alt="TATA Elxsi"
              />
            </div>
          </div>
        </SidebarContent>
        <div style={{ marginTop: "80px" }}>
          <SidebarContent className="sidebarcontentalign">
            <div className="sidebaralign">

              <div
                className={`${isActive("dashboard") ? "active" : ""} sidebar-contents`}
                onClick={() => handleItemClick("dashboard", dashboard_two)}
              >
                <img className="sidebar-logo" src={iconState.DashBoard} alt="Dashboard" /><p>Dashboard</p>
              </div>
              <div
                className={`${isActive("liceses") ? "active" : ""} sidebar-contents`}
                onClick={() => handleItemClick("liceses", liceses_two)}
              >
                <img className="sidebar-logo" src={iconState.liceses} alt="Licenses" /><p>Licenses</p>
              </div>
              <div
                className={`${isActive("Software") ? "active" : ""} sidebar-contents`}
                onClick={() => handleItemClick("Software", software_two)}
              >
                <img className="sidebar-logo" src={iconState.Software} alt="Software" /><p>Software</p>
              </div>
              <div
                className={`${isActive("SalesOrder") ? "active" : ""} sidebar-contents`}
                onClick={() => handleItemClick("SalesOrder", sales_ordertwo)}
              >
                <img className="sidebar-logo" src={iconState.SalesOrder} alt="Sales Order" /><p>Sales Order</p>
              </div>

            </div>
          </SidebarContent>
        </div>
      </ProSidebar>
    </div>

  );
};

export default Aside;
